import { Amount } from '@mews-commander/types';
import { FlexSpaceBetweenAlignCenter, SpacingMediumLeft, Responsive } from '@mews-commander/ui';
import { Typography } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { getPositiveAmount, stubNull } from '@mews-commander/utils';
import { AmountDue } from '../AmountDue';

interface Props {
    amount: Amount;
}

const Balance: React.FC<Props> = ({ amount }) => {
    const { value } = amount;
    const isAmountNegative = value < 0;
    const positiveAmount = getPositiveAmount(amount);
    const labelText = isAmountNegative ? TextKey.ToBeRefunded : TextKey.ToBePaid;

    return (
        <FlexSpaceBetweenAlignCenter>
            <Typography textStyle="bodyMedium" as="div">
                <LocalizedText textKey={labelText} />
            </Typography>
            <Responsive Default={SpacingMediumLeft} Phone={stubNull} />
            <AmountDue size="medium" isNegative={isAmountNegative} value={positiveAmount} />
        </FlexSpaceBetweenAlignCenter>
    );
};

export default Balance;
